<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content [formGroup]="form">
  <p class="secret-notice">
    The value is sent directly to AWS Secrets Manager. It cannot be viewed again in Wallit TeamAdmin.
  </p>

  <mat-form-field appearance="outline">
    <mat-label>Secret name</mat-label>
    <span matPrefix>{{ data.prefix }}</span>
    <input matInput formControlName="name" autocomplete="off" />
    <mat-hint>Use letters, numbers, +, =, ., &#64;, _, or -.</mat-hint>
    @if (form.get('name')?.hasError('required')) {
      <mat-error>Secret name is required.</mat-error>
    }
    @if (form.get('name')?.hasError('maxlength')) {
      <mat-error>Secret name cannot exceed 128 characters.</mat-error>
    }
    @if (form.get('name')?.hasError('pattern')) {
      <mat-error>
        Secret name can only contain letters, numbers, +, =, ., &#64;, _, or -.
      </mat-error>
    }
  </mat-form-field>

  @if (data.type === 'password') {
    <mat-form-field appearance="outline">
      <mat-label>{{ valueLabel }}</mat-label>
      <input matInput type="password" formControlName="value" autocomplete="new-password" />
      @if (form.get('value')?.hasError('required')) {
        <mat-error>Password is required.</mat-error>
      }
    </mat-form-field>
  } @else {
    <mat-form-field appearance="outline">
      <mat-label>{{ valueLabel }}</mat-label>
      <textarea matInput rows="12" formControlName="value" autocomplete="off"></textarea>
      @if (form.get('value')?.hasError('required')) {
        <mat-error>{{ valueLabel }} is required.</mat-error>
      }
    </mat-form-field>
  }


  @if (validationMessages.length) {
    <div class="validation-summary" role="alert" aria-live="polite">
      <strong>Complete the following before creating the secret:</strong>
      <ul>
        @for (message of validationMessages; track message) {
          <li>{{ message }}</li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="submit()">
    Create secret
  </button>
</mat-dialog-actions>
